export interface LegendItem {
  label: string;
  color: string;
}

export interface LegendProps {
  items: LegendItem[];
}

/** Horizontal color-swatch legend rendered below a chart. */
export const Legend = ({ items }: LegendProps) => (
  <ul data-slot='chart-legend' className='flex flex-wrap justify-center gap-md pt-xs'>
    {items.map(item => (
      <li key={item.label} className='flex items-center gap-xs text-xs text-foreground-muted'>
        <span aria-hidden className='size-2 rounded-full' style={{ backgroundColor: item.color }} />
        {item.label}
      </li>
    ))}
  </ul>
);

Legend.displayName = 'Legend';
